export async function getFeatured(type, count) {
    var result = await fetch("/api/frontpage/featured?type="+type+"&count="+count).then((obj) => obj.json()).catch((ex) => console.error("get Error: " + ex));
    return result;
}